import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireOpenItemsReport extends Layout {
    openBalancesOnly: Checkbox;
    sourceWireOpenItems: DataSource;
    textboxCardProvider: Textbox;
    textboxDates: Textbox;
}
